'use client';

import {
  HeroBackdropLayers,
  heroDescriptionClass,
  cn,
} from '@/components/help-center/latest-power-shared';
import { FairtradeAppearanceToggle } from '@/components/help-center/fairtrade/FairtradeAppearanceToggle';
import {
  POWER_TRADE_BUTTON_STYLE,
  POWER_TRADE_ICON_SRC,
  POWER_TRADE_URL,
  powerTradeButtonClass,
} from '@/components/help-center/powers/power-shared';
import type { ConductAppearance } from '@/lib/conduct-presentation';

type FairtradeHeroProps = {
  appearance: ConductAppearance;
  onAppearanceChange: (next: ConductAppearance) => void;
  isLight?: boolean;
};

/** Hero alinhado a Regras / Conduta / Equipe (backdrop + corte limpo no light). */
export default function FairtradeHero({
  appearance,
  onAppearanceChange,
  isLight = false,
}: FairtradeHeroProps) {
  return (
    <section
      className={cn(
        'relative z-30 overflow-hidden bg-[#030023]',
        isLight && 'border-b border-blue-900/50'
      )}
    >
      <HeroBackdropLayers className="absolute inset-0" />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#030023]"
        aria-hidden
      />

      <div className="relative z-10 mx-auto max-w-7xl px-6 pb-6 pt-32 sm:pb-8 md:pb-8 md:pt-40">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-1.5 md:gap-2">
          <div
            className="relative h-44 w-44 shrink-0 overflow-hidden rounded-full sm:h-52 sm:w-52 md:h-60 md:w-60"
            aria-hidden
          >
            <div className="fairtrade-hero-logo h-full w-full animate-fairtrade-hero-spin">
              <img
                src="/icons/tradelogo.webp"
                alt=""
                className="h-full w-full object-contain"
                width={240}
                height={240}
                draggable={false}
                decoding="async"
                loading="eager"
              />
            </div>
          </div>

          <div className="min-w-0 flex-1 sm:-ml-1 md:-ml-2">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <h1 className="font-poppins text-4xl font-bold leading-tight tracking-tight text-white md:text-5xl">
                Guia de Preços
              </h1>
              <FairtradeAppearanceToggle
                appearance={appearance}
                onChange={onAppearanceChange}
              />
            </div>
            <p className={cn('mt-2.5 max-w-3xl sm:mt-3', heroDescriptionClass)}>
              Descubra quanto valem os powers do xat, compare preços em xats e days e acompanhe as
              mudanças do mercado em um só lugar.
            </p>
            <a
              href={POWER_TRADE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={cn(powerTradeButtonClass, 'mt-4 px-5 py-2 text-[13px]')}
              style={POWER_TRADE_BUTTON_STYLE}
            >
              <img
                src={POWER_TRADE_ICON_SRC}
                alt=""
                width={22}
                height={22}
                className="h-[22px] w-[22px] shrink-0 object-contain"
                aria-hidden
                draggable={false}
              />
              ACESSAR XAT TRADE
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
